export const GET_VOE_HERO_STATS = gql`
  query VoEHeroStats($filters: VoEAnalyticsFiltersInput) {
    voeHeroStats(filters: $filters) {
      totalCompletions
      dnFormCount
      dnFormPercentage
      responseReceivedRate
      avgDaysToFirstContact
      avgTotalLifecycleDays
    }
  }
`

export const GET_VOE_COMPLETIONS_BY_CHANNEL = gql`
  query VoECompletionsByChannel($filters: VoEAnalyticsFiltersInput) {
    voeCompletionsByChannel(filters: $filters) {
      month
      dnForm
      phone
      fax
      emailExternal
      atsPlatform
      noResponse
      unknown
      total
      dnFormPercentage
    }
  }
`

export const GET_VOE_RESPONSE_RATE = gql`
  query VoEResponseRate($filters: VoEAnalyticsFiltersInput) {
    voeResponseRate(filters: $filters) {
      month
      totalCompleted
      responseReceived
      responseReceivedRate
    }
  }
`

export const GET_VOE_TIME_TO_FIRST_CONTACT = gql`
  query VoETimeToFirstContact($filters: VoEAnalyticsFiltersInput) {
    voeTimeToFirstContact(filters: $filters) {
      month
      avgDays
      count
    }
  }
`

export const GET_VOE_LIFECYCLE_BREAKDOWN = gql`
  query VoELifecycleBreakdown($filters: VoEAnalyticsFiltersInput) {
    voeLifecycleBreakdown(filters: $filters) {
      avgWaitDays
      avgActiveDays
      avgTotalDays
      medianWaitDays
      medianActiveDays
      medianTotalDays
    }
  }
`

export const GET_VOE_AUDIT_TRAIL_ACTIVITY = gql`
  query VoEAuditTrailActivity($filters: VoEAnalyticsFiltersInput) {
    voeAuditTrailActivity(filters: $filters) {
      summary {
        automated
        assisted
        manual
        total
        byType {
          type
          automated
          assisted
          manual
          total
        }
      }
      buckets {
        period
        email
        call
        fax
        ats
        total
      }
    }
  }
`

export const GET_VOE_OUTREACH_SUMMARY = gql`
  query VoEOutreachSummary($filters: VoEAnalyticsFiltersInput) {
    voeOutreachSummary(filters: $filters) {
      automated
      assisted
      manual
      total
      byType {
        type
        automated
        assisted
        manual
        total
      }
    }
  }
`

export const GET_VOE_AVG_OUTREACH_ATTEMPTS = gql`
  query VoEAvgOutreachAttempts($filters: VoEAnalyticsFiltersInput) {
    voeAvgOutreachAttempts(filters: $filters) {
      completedAvg
      noResponseAvg
      totalAvg
      completedCount
      noResponseCount
      totalCount
    }
  }
`

export const GET_VOE_COMPLETIONS_BY_ASSIGNEE = gql`
  query VoECompletionsByAssignee($filters: VoEAnalyticsFiltersInput) {
    voeCompletionsByAssignee(filters: $filters) {
      totalCompletions
      items {
        assigneeId
        assigneeName
        total
        dnForm
        phone
        fax
        emailExternal
        atsPlatform
        noResponse
        unknown
      }
    }
  }
`

export const GET_VOE_AUTONOMY_SPLIT = gql`
  query VoEAutonomySplit($filters: VoEAnalyticsFiltersInput) {
    voeAutonomySplit(filters: $filters) {
      totals {
        autonomous
        assisted
        manual
        total
      }
      buckets {
        period
        autonomous
        assisted
        manual
        total
      }
    }
  }
`
